module.exports = __webpack_public_path__ + "img/accountCount.9791adfd.png";